<template>
  <nav aria-label="مسیر صفحه" class="flex items-center gap-1.5 text-sm">
    <template v-for="(item, i) in items" :key="i">
      <NuxtLink v-if="item.to" :to="item.to"
        class="cursor-pointer text-muted-foreground transition-colors hover:text-foreground">
        {{ item.label }}
      </NuxtLink>

      <span v-else class="font-medium text-primary-black">
        {{ item.label }}
      </span>

      <span v-if="i < items.length - 1" class="text-base text-border" aria-hidden="true">
        ›
      </span>
    </template>
  </nav>
</template>

<script setup lang="ts">
defineProps<{
  items: { label: string; to?: any }[]
}>()

const router = useRouter()
</script>